import { InstaPayLogo } from "@/Svg/Svg";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import Languages from "../../Languages";

const SignUpHeader = ({ storeHashId = "", step, setStep }) => {
  const navigate = useNavigate();
  const [lang, setLang] = useState("English");
  return (
    <div className="w-full p-3 flex items-center justify-between border-2  border-[#E4E3E5] ">
      <div
        onClick={() => navigate(storeHashId ? `/store/${storeHashId}` : "/")}
        className="w-auto flex cursor-pointer items-center justify-center"
      >
        <InstaPayLogo width="40" height="30" />
        <span className="font-bold text-lg text-[#000] ">InstaPay</span>
      </div>
      {step !== 5 && (
        <div
          className="hidden 
   lg:flex
    px-4 py-2
    justify-center
    items-center
    gap-2
    rounded-full
    bg-white
    shadow-[0_3px_8px_0_rgba(0_0_0_/_0.05)]
  "
        >
          Step {step} of 4
        </div>
      )}
    <Languages />
    </div>
  );
};

export default SignUpHeader;
